import { z } from 'zod'
import navigationData from '@/data/config/navigation.json'

const RouteConfigSchema = z.object({
  enabled: z.boolean(),
  label: z.string(),
  showInNav: z.boolean()
})

const NavigationConfigSchema = z.object({
  routes: z.record(z.string(), RouteConfigSchema)
})

export type RouteConfig = z.infer<typeof RouteConfigSchema>
export type NavigationConfig = z.infer<typeof NavigationConfigSchema>

let cachedConfig: NavigationConfig | null = null

export function loadNavigationConfig(): NavigationConfig {
  if (cachedConfig) return cachedConfig

  const result = NavigationConfigSchema.safeParse(navigationData)

  if (!result.success) {
    // eslint-disable-next-line no-console
    console.error('Navigation config validation failed:', result.error.issues)
    throw new Error('Invalid navigation configuration')
  }

  cachedConfig = Object.freeze(result.data) as NavigationConfig
  return cachedConfig
}

export function getEnabledRoutes(): Array<{ name: string; label: string }> {
  const config = loadNavigationConfig()
  return Object.entries(config.routes)
    .filter(([_, route]) => route.enabled && route.showInNav)
    .map(([name, route]) => ({ name, label: route.label }))
}

export function isRouteEnabled(routeName: string): boolean {
  const config = loadNavigationConfig()
  return config.routes[routeName]?.enabled ?? true
}
